<template>
  <div class="searchPage">
    <Header v-if="isPC" :kword="keyword" @getKeyword='getKeyword'></Header>
    <SearchInput v-if="!isPC" :kword="keyword" :allEstate="allEstate" :saleEstate="saleEstate" @getKeyword='getKeyword'></SearchInput>
    <FilterMenu :clearFilter="clearFilter" :isPC="isPC" v-if="showMenu" @setFilter='getFilterData' :filter="filter"></FilterMenu>
    <div class="requesttips" v-if="showTips">正在加载数据…</div>
    <EstateList v-if="!isPC" :eList="searchResult" :isList="true"></EstateList>
    <PCEstateList v-if="isPC" :eList="searchResult"></PCEstateList>
    <p class="morelist" v-if="searchResult.length>=10"><span @click="getNextPageEstate">{{moreText}}</span></p>
    <div v-if="showNullTips&&!showTips" class="tipsbox">
      <!-- <div class="box"><p class="tips1">没有找到相关楼盘！</p></div>
      <p class="tips2">
        稀缺全城热搜好房，第一时间通知
        <span>免费订阅通知</span>
      </p> -->
      <p class="tips2">没有找到相关楼盘！</p>
      <p class="rtitle" v-if="!isPC">为你推荐热销楼盘</p>
      <EstateList v-if="!isPC" :isRecom="true"></EstateList>
      <PCEstateList v-if="isPC" :isRecom="true"></PCEstateList>
    </div>


  </div>
</template>

<script>
import Header from '@/components/public/Header'
import SearchInput from '@/components/public/SearchInput'
import FilterMenu from '@/components/public/FilterMenu'
import EstateList from '@/components/public/EstateList'
import PCEstateList from '@/components/public/PCEstateList'
export default {
  name: 'Search',
  props:{
    isPC:Boolean,
    allEstate:Boolean,
    saleEstate:Boolean,
    keyword:String,
    filter:Object,
  },
  components:{
    'Header': Header,
    'SearchInput': SearchInput,
    'FilterMenu': FilterMenu,
    'EstateList': EstateList,
    'PCEstateList': PCEstateList,
  },
  data () {
    return {
      mtxFisrtLocation:this.$route.query.mtxFisrtLocation,
      searchResult:[],
      clearFilter:false,
      showNullTips:0,
      showMenu:0,
      showTips:0,
      urlData:null,
      currPage:1,
      totalPage:1,
      moreText:'点击加载更多'
    }
  },
  mounted(){
    var _this = this;
    if(_this.allEstate){
      if(JSON.stringify(_this.filter)=='{}'){
        _this.urlData='';
      }else{
        _this.showMenu=1;
      }
    }
    if(_this.saleEstate){
      _this.urlData='statusId='+this.storage.get('saleId'); 
    }
    if(_this.keyword!=undefined){
      _this.getKeyword(_this.keyword);
    }
  },
  computed:{
    listenUrlData(){
      return this.urlData;
    }
  },
  watch:{
    listenUrlData:function(boo){
      this.getEstate();
    }
  },
  methods:{
    getEstate:function(){
      this.searchResult = [];
      this.showMenu=1;
      this.showTips=1;
      if(this.saleEstate && this.urlData.indexOf('statusId')==-1){
        this.urlData=  this.urlData+ '&statusId='+this.storage.get('saleId'); 
      }
      
      if(this.mtxFisrtLocation && this.urlData.indexOf('mtxFisrtLocation')==-1){
        this.urlData=  this.urlData+ '&mtxFisrtLocation='+this.mtxFisrtLocation; 
      }

      this.$http.get('/api/estate/getEstateListByParams?'+this.urlData).then((response)=>{
        if(response.data.result){
          this.searchResult = response.data.result;
          this.currPage = JSON.parse(response.data.page).page;
          this.totalPage = JSON.parse(response.data.page).totalPages;
        }else{
          this.searchResult = [];
        }
        this.defaultList = this.searchResult;
        this.showTips = 0;
        this.showNullTips = this.searchResult.length<=0;

        // 微信获取密钥分享，全部楼盘
        this.getSignatureShare();
      }).catch((response)=>{
        console.log(response)
      })
    },
    getNextPageEstate:function(){
      if(this.currPage<this.totalPage){
        this.currPage++;
        var page='';
        if(this.urlData){
          page='&pn='+this.currPage;
        }else{
          page='pn='+this.currPage;
        }
       
        this.moreText='正在加载中...';
        this.$http.get('/api/estate/getEstateListByParams?'+this.urlData+page).then((response)=>{
          if(response.data.result.length<10){
            this.moreText='已加载全部'
          }else{
            this.moreText='点击加载更多'
          }
          if(response.data.result){
            this.searchResult=this.searchResult.concat(response.data.result);
          }
        }).catch((response)=>{
          console.log(response)
        })
      }
    },
    getFilterData:function(data){
      this.$store.commit('updateFilterStr',data);
      this.clearFilter=false;
      var urlstr='';
      if(this.keyword){
        urlstr+='q='+this.keyword+'&';
      }
      if(data.locationId){
        urlstr+='locationId='+data.locationId
      }
      if(data.plateId){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='plateId='+data.plateId
      }
      if(data.priceId){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='priceId='+data.priceId
      }
      if(data.houseTypeId){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='houseTypeId='+data.houseTypeId
      }
      
      if(this.mtxFisrtLocation){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='mtxFisrtLocation='+this.mtxFisrtLocation
      }
      if(data.statusId){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='statusId='+data.statusId
      }
      if(data.typeId){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='typeId='+data.typeId
      }
      if(data.sortNumber){
        if(urlstr!=''){
          urlstr+='&'
        }
        urlstr+='sort='+data.sortNumber
      }
      if(this.$route.path=='/estateSale'){
        this.urlData='statusId='+this.storage.get('saleId'); 
        this.urlData+='&'+urlstr;
      }else{
        this.urlData=urlstr;
      }
    },
    getKeyword:function(data){
      data = data.replace(/(^\s+)|(\s+$)/g, "");
      this.urlData = 'q='+data;
      if(data){
        this.$router.push({query:{'q':data}});
      }else{
        this.$router.push({query:{}});
      }
      this.clearFilter=true;
    },
    // 微信获取密钥分享
    getSignatureShare(){
      var imgUrl = this.searchResult.length>0 ? this.searchResult[0].path : '';
      var shareObj = {
        link: window.location.href,
        title: document.title+'-全部楼盘',
        desc: document.title+'-全部楼盘',
        imgUrl: imgUrl,
        logoIndex: this.$store.state.domainIndex
      };
      this.$http.get('/api/wechat/getSignatureInfo?url='+shareObj.link).then((response)=>{
        if(response && response.data.result){
          this.share.weixinShare(shareObj, response.data.result);
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
  }
}
</script>

<style scoped>
body{background:#f5f5f5;}
/*.searchPage{padding-bottom:20px;}*/
.tips1{color:#666;padding-left:25px;margin-top:10px;}
.tips2{background:#fff;margin:10px 25px 0;border-radius:2px;padding:30px;text-align:center;color:#2e303a;}
.tips2 span{display:block;width:170px;line-height:43px;background:#ffd03d;color:#333;font-size:15px;border-radius:30px;margin:20px auto 0;}
.rtitle{font-size:20px;color:#2e303a;font-weight:bold;margin-top:30px;padding-left:15px;}
.requesttips{text-align:center;padding:10px 20px;}
.morelist{text-align:center;color:#2e303a;padding:5px;font-size:13px;cursor:pointer;}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue